import { Host, h } from "@stencil/core";
import { FallbackRenderInfo } from "../../utils/FallbackRenderInfo";
import { toString } from "../../utils/utils";
function defaultOptionsRender(options, optionClicked) {
    return h("div", { style: { display: 'flex', flexDirection: "column" } }, (options || []).map((option) => {
        return h("div", { style: { width: "100%" }, onClick: () => optionClicked(option) }, option.displayValue);
    }));
}
function selectedValuesRender(selectedValues, remove) {
    return selectedValues.map((value, index) => {
        if (value === null) {
            // Render a loading indicator for null values
            return (h("span", { key: index, class: "loading-indicator" }, "Loading..."));
        }
        // Render a pill for string values
        return (h("div", { key: index, class: "pill" }, value, remove && h("button", { class: "close-icon", onClick: () => remove(value), "aria-label": `Remove ${value}` }, "\u00D7")));
    });
}
export class ApieComboboxInput {
    constructor() {
        this.name = undefined;
        this.label = null;
        this.disabled = false;
        this.removeDisabled = false;
        this.value = undefined;
        this.selectedValues = [];
        this.options = [];
        this.touched = undefined;
        this.optionRender = defaultOptionsRender;
        this.autocompleteUrl = undefined;
        this.renderInfo = new FallbackRenderInfo();
        this.pending = null;
        this.pendingValue = null;
        this.displayValues = {};
    }
    refetch() {
        this.pendingValue = this.value;
        return this.pending = this.fetch(this.value);
    }
    fetch(value) {
        return fetch(toString(this.autocompleteUrl), {
            method: 'POST',
            headers: { 'Accept': 'application/json', "Content-Type": "application/json" },
            body: JSON.stringify({
                input: value
            })
        }).then((response) => {
            return response.json();
        }).then((value) => {
            return value;
        });
    }
    onValueUpdate() {
        if (this.autocompleteUrl && this.value) {
            if (!this.pending || this.value !== this.pendingValue) {
                this.pendingValue = this.value;
                const value = this.value;
                const currentUrl = this.autocompleteUrl;
                this.refetch().then((data) => {
                    if (this.pendingValue !== value || currentUrl !== this.autocompleteUrl) {
                        return;
                    }
                    this.pending = null;
                    this.pendingValue = null;
                    this.options = data;
                });
            }
        }
        else {
            this.pending = null;
            this.pendingValue = null;
        }
    }
    makeList(value) {
        const todo = [];
        const result = value.map((v) => {
            if (Object.hasOwnProperty.call(this.displayValues, v)) {
                return this.displayValues[v];
            }
            todo.push(v);
            return null;
        });
        todo.forEach((unknownDisplay) => {
            this.fetch(unknownDisplay).then((found) => {
                for (let item of found) {
                    if (toString(item.value) === toString(unknownDisplay)) {
                        this.displayValues[unknownDisplay] = item.displayValue;
                        this.displayValues = Object.assign({}, this.displayValues);
                        return;
                    }
                }
                this.displayValues[unknownDisplay] = unknownDisplay;
                this.displayValues = Object.assign({}, this.displayValues);
            });
        });
        return result;
    }
    render() {
        var _a;
        const clickOption = (value) => {
            this.displayValues[value.value] = value.displayValue;
            this.optionClicked.emit(value);
            this.value = '';
        };
        const remove = (value) => {
            this.selectedValues = this.selectedValues.filter((v) => v !== value);
            this.selectedValueChanged.emit(this.selectedValues);
        };
        return (h(Host, { key: '51ee7a1851813a0a32b63997886699d5bd8c6596' }, selectedValuesRender(this.makeList(this.selectedValues), this.removeDisabled ? null : remove), this.renderInfo.renderSingleInput([
            'comboboxtext',
            'text'
        ], {
            name: this.name,
            label: (_a = this.label) !== null && _a !== void 0 ? _a : this.name,
            disabled: this.disabled,
            value: this.value,
            valueChanged: (newValue) => this.value = toString(newValue),
            validationResult: { valid: true, messages: [] },
            serverValidationError: {},
            renderInfo: this.renderInfo,
            currentFieldWrapper: (v) => v,
            touched: this.touched,
            onTouched: () => { this.touched = true; this.fieldTouched.emit(true); },
            additionalSettings: {
                options: (this.options || []).map((result) => {
                    return { value: result.value, name: result.displayValue };
                })
            }
        }), (this.value || !this.autocompleteUrl) && this.optionRender(this.options, clickOption), h("slot", { key: 'd480d6e1890f70d90d133f189ceb38a35c7d6cb7' })));
    }
    static get is() { return "apie-combobox-input"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["apie-combobox-input.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["apie-combobox-input.css"]
        };
    }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "name",
                "reflect": true
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string|null",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "label",
                "reflect": true,
                "defaultValue": "null"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "removeDisabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "remove-disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "value": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "value",
                "reflect": true
            },
            "selectedValues": {
                "type": "unknown",
                "mutable": true,
                "complexType": {
                    "original": "Array<string>",
                    "resolved": "string[]",
                    "references": {
                        "Array": {
                            "location": "global",
                            "id": "global::Array"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "[]"
            },
            "options": {
                "type": "unknown",
                "mutable": true,
                "complexType": {
                    "original": "Array<ComboboxResult>",
                    "resolved": "ComboboxResult[]",
                    "references": {
                        "Array": {
                            "location": "global",
                            "id": "global::Array"
                        },
                        "ComboboxResult": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::ComboboxResult"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "[]"
            },
            "touched": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "touched",
                "reflect": true
            },
            "optionRender": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "(options: Array<ComboboxResult>, optionClicked: (result: ComboboxResult) => void) => VNode|VNode[]",
                    "resolved": "(options: ComboboxResult[], optionClicked: (result: ComboboxResult) => void) => VNode | VNode[]",
                    "references": {
                        "Array": {
                            "location": "global",
                            "id": "global::Array"
                        },
                        "ComboboxResult": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::ComboboxResult"
                        },
                        "VNode": {
                            "location": "import",
                            "path": "@stencil/core",
                            "id": "node_modules::VNode"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "defaultOptionsRender"
            },
            "autocompleteUrl": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | null",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "autocomplete-url",
                "reflect": false
            },
            "renderInfo": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "RenderInfo",
                    "resolved": "RenderInfo",
                    "references": {
                        "RenderInfo": {
                            "location": "import",
                            "path": "../../utils/RenderInfo",
                            "id": "src/utils/RenderInfo.tsx::RenderInfo"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "new FallbackRenderInfo()"
            }
        };
    }
    static get states() {
        return {
            "pending": {},
            "pendingValue": {},
            "displayValues": {}
        };
    }
    static get events() {
        return [{
                "method": "valueChanged",
                "name": "valueChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }, {
                "method": "selectedValueChanged",
                "name": "selectedValueChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "string[]",
                    "resolved": "string[]",
                    "references": {}
                }
            }, {
                "method": "fieldTouched",
                "name": "fieldTouched",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                }
            }, {
                "method": "optionClicked",
                "name": "optionClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "ComboboxResult",
                    "resolved": "ComboboxResult",
                    "references": {
                        "ComboboxResult": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::ComboboxResult"
                        }
                    }
                }
            }];
    }
    static get methods() {
        return {
            "refetch": {
                "complexType": {
                    "signature": "() => Promise<Array<ComboboxResult>>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "ComboboxResult": {
                            "location": "import",
                            "path": "../../utils/FormDefinition",
                            "id": "src/utils/FormDefinition.ts::ComboboxResult"
                        },
                        "Array": {
                            "location": "global",
                            "id": "global::Array"
                        }
                    },
                    "return": "Promise<ComboboxResult[]>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get watchers() {
        return [{
                "propName": "autocompleteUrl",
                "methodName": "onValueUpdate"
            }, {
                "propName": "value",
                "methodName": "onValueUpdate"
            }];
    }
}
//# sourceMappingURL=apie-combobox-input.js.map
